/* eslint-disable no-unused-vars */
import React from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';

const styles = {
  teamStat: (props) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: props.reverse ? 'flex-end' : 'flex-start',
  }),
  ranking: (props) => ({
    display: 'flex',
    alignItems: 'center',
    flexDirection: props.reverse ? 'row-reverse' : 'row',
  }),
  spacer: {
    height: '69px',
  },
  statsrow: (props) => ({
    display: 'flex',
    alignItems: 'center',
    // marginBottom: '10px',
    flexDirection: props.reverse ? 'row-reverse' : 'row',
  }),
  bar_stacked: (props) => ({
    height: '6px',
    width: props.barstackedwidth ? props.barstackedwidth : '130px',
    display: 'flex',
    margin: props.reverse ? '0 0 0 10px' : '0 10px 0 0',
    flexDirection: props.reverse ? 'row-reverse' : 'row',
  }),
  bar_stats: (props) => ({
    height: '100%',
    backgroundColor: props.reverse ? '#62AD1D' : '#F9981D',
    transition: 'width .6s ease',
  }),
  bar_stats_gray: {
    height: '100%',
    backgroundColor: '#D8D8D8',
  },
  smalltext: {
    padding: '0 5px',
    fontSize: '10px',
  },
  separator: {
    height: '15px',
  },
  value: (props) => ({
    minWidth: '20px',
    textAlign: props.reverse ? 'right' : 'left',
  }),
  '@media (max-width: 601px)': {
    spacer: {
      height: '63px',
    },
    separator: {
      height: '16px',
    },
  },
};

const TeamStats = ({
  classes, team, mobile,
}) => (
  <div className={classes.teamStat}>
    <div className={classes.ranking}>
      <div className={classes.value}>{team.fifarank}</div>
      <div className={classes.bar_stacked}>
        {/* <div
          className={classes.bar_stats}
          style={{
            width: `${(100 * (33 - Number(team.fifaintournament))) / 32}%`,
          }}
        />
        <div
          className={classes.bar_stats_gray}
          style={{
            width: `${100 - ((100 * (33 - Number(team.fifaintournament))) / 32)}%`,
          }}
        /> */}
      </div>
    </div>
    <div className={classes.ranking}>
      <div className={classes.value}>{team.elorank}</div>
      <div className={classes.bar_stacked}>
        {/* <div
          className={classes.bar_stats}
          style={{
            width: `${(100 * (33 - Number(team.elointournament))) / 32}%`,
          }}
        />
        <div
          className={classes.bar_stats_gray}
          style={{
            width: `${100 - ((100 * (33 - Number(team.elointournament))) / 32)}%`,
          }}
        /> */}
      </div>
    </div>
    <div>
      <div className={classes.spacer} />
      <div className={classes.statsrow}>
        {
          Number(team.won)
          + Number(team.drawn)
          + Number(team.lost)
        }
      </div>
      <div className={classes.statsrow}>
        <div className={classes.value}>{team.won}</div>
        <div className={classes.bar_stacked}>
          <div
            className={classes.bar_stats}
            style={{
              width: `${100 * (
                Number(team.won) / (
                  Number(team.won)
            + Number(team.drawn)
            + Number(team.lost)
                ))}%`,
            }}
          />
          <div
            className={classes.bar_stats_gray}
            style={{
              width: `${100 * (1 - (
                Number(team.won) / (
                  Number(team.won)
            + Number(team.drawn)
            + Number(team.lost)
                )))}%`,
            }}
          />
        </div>
        <div className={classes.smalltext}>
          (
          {(100 * (
            Number(team.won) / (
              Number(team.won)
              + Number(team.drawn)
              + Number(team.lost)
            ))).toPrecision(3)}
          %)
        </div>
      </div>
      <div className={classes.statsrow}>
        <div className={classes.value}>{team.drawn}</div>
        <div className={classes.bar_stacked}>
          <div
            className={classes.bar_stats}
            style={{
              width: `${100 * (
                Number(team.drawn) / (
                  Number(team.won)
            + Number(team.drawn)
            + Number(team.lost)
                ))}%`,
            }}
          />
          <div
            className={classes.bar_stats_gray}
            style={{
              width: `${100 * (1 - (
                Number(team.drawn) / (
                  Number(team.won)
            + Number(team.drawn)
            + Number(team.lost)
                )))}%`,
            }}
          />
        </div>
        <div className={classes.smalltext}>
          (
          {(100 * (
            Number(team.drawn) / (
              Number(team.won)
              + Number(team.drawn)
              + Number(team.lost)
            ))).toPrecision(3)}
          %)
        </div>
      </div>
      <div className={classes.statsrow}>
        <div className={classes.value}>{team.lost}</div>
        <div className={classes.bar_stacked}>
          <div
            className={classes.bar_stats}
            style={{
              width: `${100 * (
                Number(team.lost) / (
                  Number(team.won)
            + Number(team.drawn)
            + Number(team.lost)
                ))}%`,
            }}
          />
          <div
            className={classes.bar_stats_gray}
            style={{
              width: `${100 * (1 - (
                Number(team.lost) / (
                  Number(team.won)
            + Number(team.drawn)
            + Number(team.lost)
                )))}%`,
            }}
          />
        </div>
        <div className={classes.smalltext}>
          (
          {(100 * (
            Number(team.lost) / (
              Number(team.won)
                + Number(team.drawn)
                + Number(team.lost)
            ))).toPrecision(3)}
          %)
        </div>
      </div>
      <div className={classes.separator} />
      <div className={classes.statsrow}>
        {team.goalsscored}
        <span className={classes.smalltext} style={{ display: mobile ? 'none' : 'block' }}>
          (
          {(Number(team.goalsscored) / (
            Number(team.won)
                + Number(team.drawn)
                + Number(team.lost)
          )).toPrecision(3)}
          {' '}
          goals per game)
        </span>
      </div>
      <div className={classes.statsrow}>
        {team.goalsreceived}
        <span className={classes.smalltext} style={{ display: mobile ? 'none' : 'block' }}>
          (
          {(Number(team.goalsreceived) / (
            Number(team.won)
                + Number(team.drawn)
                + Number(team.lost)
          )).toPrecision(3)}
          {' '}
          goals per game)
        </span>
      </div>
    </div>
  </div>
);

TeamStats.propTypes = {
  classes: PropTypes.object.isRequired,
  team: PropTypes.object.isRequired,
  mobile: PropTypes.bool,
};

TeamStats.defaultProps = {
  mobile: false,
};

TeamStats.defaultProps = {};

export default injectSheet(styles)(TeamStats);
